module.exports = __webpack_public_path__ + "static/img/bg_10.c510732.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/bg_10.png
// module id = 774
// module chunks = 1